import { jumboButtons } from './[type]/type.config';
import { itemLink, generate } from './shared.config';
import _ from 'lodash-es';

export default (data) => {
  let sort = null;
  if (data.filterPage) {
    sort = { value: 'price', desc: data.filterPage.slug === 'most-expensive' };
  }
  return _.merge(generate(data), {
    itemType: `Gloves`,
    jumbo: {
      title: `All CS2 Gloves`,
      text: `Browse a list of all Gloves. Sort and filter the items to ensure you find what you're looking for!`,
      imagePosition: 'right',
      modifiers: ['reverse'],
      buttons: jumboButtons(data),
    },
    sort,
    itemLink,
    pagination: {
      current: data.page || 1,
      link: `/skins/gloves`,
    },
  });
};
